import type { HTMLAttributes, Ref } from 'react';
import { cx } from '../internal/cx';

export interface VisuallyHiddenProps extends HTMLAttributes<HTMLSpanElement> {
  ref?: Ref<HTMLSpanElement>;
}

/** Content available to assistive technology but not rendered visually. */
export function VisuallyHidden({ className, ...rest }: VisuallyHiddenProps) {
  return <span className={cx('sr-only', className)} {...rest} />;
}
